import Vue from 'vue'
import Router from 'vue-router'

import Discovery from '@/pages/discovery/Home.vue'
import Cooperation from '@/pages/cooperation/cooperation.vue'
import AboutAs from '../pages/aboutAs/index'
import helpCenter from "../pages/helpCenter/helpCenter";
import lawsAndRegulations from '../pages/lawsAndRegulations/index'

Vue.use(Router)

export default new Router({
	routes: [
		{
			name: 'discovery',
			path: '/discovery/home',
			component: Discovery,
			meta: {
				title: '搭把手-发现'
			}
		},
		{
			name: 'cooperation',
			path: '/cooperation/cooperation',
			component: Cooperation,
			meta: {
				title: '搭把手-公益合作'
			}
		},
		{
			name: 'helpCenter',
			path: '/helpCenter/helpCenter',
			component: helpCenter,
			meta: {
				title: '搭把手-帮助中心'
			}
		},
		{
			name: 'aboutus',
			path: '/aboutAs/index',
			component: AboutAs,
			meta: {
				title: '搭把手-关于我们'
			}
		},

		{
			name: 'lawsAndRegulations',
			path: '/lawsAndRegulations/index',
			component: lawsAndRegulations,
			meta: {
				title: '搭把手-法律法规'
			}
		},

	]
})
